/*
 * @Author: 'yanghongye' yanghongye@jtexpress.com
 * @Date: 2026-06-30 08:49:46
 * @LastEditors: 'yanghongye'
 * @LastEditTime: 2026-06-30 08:59:26
 * @Description: file content
 */
/**
 * 默认常量表 —— 所有允许被国家覆写的常量，必须在此声明默认值
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：Module-Page-Constant（连字符分隔，每段大驼峰）
 * ═══════════════════════════════════════════════════════════
 *
 *  层级         含义                           示例
 * ─────────────────────────────────────────────────────────
 *  Module       所属功能模块                   Common / Address / Store / Print
 *  Page         所属页面或作用域               Api / Currency / Label
 *  Constant     具体常量语义                   Code / Symbol / Size
 *
 * 多模块/多页面共用的常量，Module 使用 "Common"：
 *   例：'Common-Api-CountryCode'（全局接口头信息）
 *       'Common-Currency-Symbol'（全局货币符号）
 *       'Common-Sys-Code'（全局请求头 sysCode）
 *
 * 约定：新增常量先在这里加 key + 默认值，再去 viewPages/<country>/config/constants.ts 覆写
 */
const standardConstants = {
  // ─── Common 通用 / 多模块共用 ──────────────────────────
  /** API 请求头中的 country 字段值（后端约定，全局共用） */
  'Common-Api-CountryCode': 'SG' as string,

  /** 货币符号（订单、COD、首页等多模块共用） */
  'Common-Currency-Symbol': 'S$' as string,

  /** sysCode 请求头（全局共用） */
  'Common-Sys-Code': 'SITE' as string,

  // ─── Address 地址模块 ──────────────────────────────────
  /** 地址选择器 label 文案 */
  'Address-Selector-Label': '省/市/县' as string,

  /** 地址排序方向：-1 省→县，1 县→省 */
  'Address-Label-Sort': -1 as number,
  /** 地址列表是否需要邮箱 */
  'Address-Column-Email': false as boolean,

  // ─── Store 站点设置 / Print 打印模块 ──────────────────
  /** 打印面单默认尺寸描述 */
  'Store-PrintLabel-Size': '76x150' as string,
  /** 打印面单第二尺寸描述 */
  'Store-PrintLabel-Size2': '' as string,
  /** 可用面单模板列表（空数组表示保持原有硬编码单选） */
  'Store-PrintLabel-Templates': [] as { id: number; name: string; size: string; templateKey: string }[],
  // 全局品牌标识 区别home与yoyi 默认yoyi
  'Common-Brand-Name': 'Yoyi' as string,

  // ─── LearningCenter 学习中心模块 ──────────────────────────
  /** 学习中心 - 沙滩说PC地址（根据环境不同） */
  'LearningCenter-Sandstalk-Url': '' as string,
  /** 学习中心 - 开发者账号标识 */
  'LearningCenter-Provider': '' as string,
  /** 学习中心 - 身份标识前缀 */
  'LearningCenter-IdentifierPrefix': '' as string,
  /** 学习中心 - 图标路径 */
  'LearningCenter-Icon-Path': 'default' as string,

}

export type StandardConstants = typeof standardConstants
export default standardConstants
